import { consoleRoutes } from "@sagot/constants";

/** `?view=bookings`: the Bookings view of the Leads page (backend notification links use it too). */
export const BOOKINGS_VIEW = "bookings";

export function bookingsHref(workspaceSlug: string): string {
  return `${consoleRoutes.leads(workspaceSlug)}?view=${BOOKINGS_VIEW}`;
}

export function integrationsHref(workspaceSlug: string): string {
  return consoleRoutes.settings(workspaceSlug, "integrations");
}
